import Config from './Config';

// Prices from this endpoint already include commission and product tax.
export async function getProductVariations(productId) {
    const origin = Config.ADMIN_BASE_URL.replace(/\/+$/, '');
    const response = await fetch(`${origin}/api/v1/products/${encodeURIComponent(productId)}/variations`);
    if (!response.ok) throw new Error('Unable to load current variant prices. Please try again.');
    const data = await response.json();
    if (!Array.isArray(data.variations)) throw new Error('Unable to load current variant prices. Please try again.');
    return {
        requiresVariant: data.requiresVariant === true,
        variations: data.variations.map(item => ({
            ...item,
            rows: (item.attributes || []).map(attribute => ({
                name: attribute.name,
                values: [[attribute.value, attribute.unit].filter(Boolean).join(' ')]
            }))
        }))
    };
}